import {useCallback} from 'react';
import Papa from 'papaparse';
import {getDateWithTimeString} from '@/helpers/shadcn/utils';
import {
  FIELD_MAP,
  buildTemplateHeaders
} from '@/containers/Activity/WheelOfFortuneAttributes/wofQuizConstants';

const buildTranslationRow = (translations, languages) => {
  const row = {};
  languages.forEach((lang) => {
    const suffix = lang.code;
    const t = translations?.[suffix] || {};
    FIELD_MAP.forEach((f) => {
      row[`${f.header} ${suffix}`] = t[f.prop] || '';
    });
  });
  return row;
};

export function useWofQuestions({languages}) {
  const handleDownloadTemplate = useCallback(
    (existingQuestions = []) => {
      const headers = buildTemplateHeaders(languages);
      const sources =
        existingQuestions.length > 0 ? existingQuestions : [{translations: {}}];
      const rows = sources.map((q) =>
        buildTranslationRow(q.translations || {}, languages)
      );

      const csv = Papa.unparse({fields: headers, data: rows});
      const blob = new Blob(['\uFEFF' + csv], {
        type: 'text/csv;charset=utf-8;'
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `WOF_Quiz_Template_${getDateWithTimeString()}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
    [languages]
  );

  return {
    handleDownloadTemplate
  };
}
